import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

export default function GlobalCursor() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY })
    }

    document.addEventListener('mousemove', handleMouseMove)
    return () => document.removeEventListener('mousemove', handleMouseMove)
  }, [])

  return (
    <>
      {/* Primary Gradient Circle */}
      <motion.div
        className="fixed pointer-events-none z-[-1]"
        style={{
          left: mousePosition.x - 600,
          top: mousePosition.y - 600,
          opacity: 0.15,
        }}
      >
        <img
          src="/gradient-cursor-bg.webp"
          alt="Cursor gradient background"
          width={1200}
          height={1200}
          className="rounded-full blur-xl"
          style={{
            width: '1200px',
            height: '1200px',
            objectFit: 'cover',
          }}
          onError={(e) => console.error('Image failed to load:', e)}
          onLoad={() => console.log('Image loaded successfully')}
        />
      </motion.div>

      {/* Secondary Gradient Circle */}
      <motion.div
        className="fixed pointer-events-none z-[-1]"
        style={{
          left: mousePosition.x - 400,
          top: mousePosition.y - 400,
          opacity: 0.2,
        }}
      >
        <img
          src="/gradient-cursor-bg.webp"
          alt="Cursor gradient background"
          width={800}
          height={800}
          className="rounded-full blur-lg"
          style={{
            width: '800px',
            height: '800px',
            objectFit: 'cover',
          }}
          onError={(e) => console.error('Image failed to load:', e)}
          onLoad={() => console.log('Image loaded successfully')}
        />
      </motion.div>
    </>
  )
}